import { Injectable } from '@angular/core';

import { CamLazyTranslationService } from '@camelot/translation';

@Injectable({
  providedIn: 'root',
})
export class CamTranslationPlanning extends CamLazyTranslationService {
  constructor() {
    super('planning');
  }
}
